import instantsearch from 'instantsearch.js';

const renderHits = (hits, list, widgetParams) => {
  hits.forEach((hit) => {
    const item = document.createElement('li');
    item.className = 'autocomplete__item';
    item.innerHTML = instantsearch.highlight({ attribute: 'label', hit });
    item.addEventListener(
      'click',
      function () {
        widgetParams.onSelect(hit);
      },
      false,
    );
    item.addEventListener(
      'mouseenter',
      function (e) {
        const selected = widgetParams.container.querySelector(
          '.autocomplete__item.selected',
        );
        if (selected) {
          selected.classList.remove('selected');
        }
        e.target.classList.add('selected');
      },
      false,
    );
    item.addEventListener(
      'mouseleave',
      function (e) {
        e.target.classList.remove('selected');
      },
      false,
    );
    list.appendChild(item);
  });
};

export default (renderOptions) => {
  const { hits, results, widgetParams } = renderOptions;

  widgetParams.container.innerHTML = '';

  if (results /*  && results.query */) {
    if (hits.length > 0) {
      // render matching results
      const list = document.createElement('ol');
      list.className = 'autocomplete__list';
      renderHits(hits, list, widgetParams);

      widgetParams.container.appendChild(list);
    } else {
      widgetParams.container.innerHTML = `<div class="autocomplete__empty">No results for <q>${results.query}</q></div>`;
    }
  }
};
